import { Fragment, PureComponent } from 'react';
import PropTypes from 'prop-types';

import { selectableItem } from '~/components/selectable-item';
import { TimeSlot } from '../../time-slot';
import { msToAmPmHours } from '~/routes/utils';

const SelectableTimeSlot = selectableItem(TimeSlot);

export class TimeSlotsList extends PureComponent {
  render() {
    const { slots, selectedTimeSlot, selectTimeSlot } = this.props;

    return (
      <Fragment>
        {slots.map((slot) => (
          <li key={slot.from}>
            <SelectableTimeSlot
              propName="slot"
              slot={slot}
              isChecked={slot.from === selectedTimeSlot.from}
              onChange={selectTimeSlot}
              title={`${msToAmPmHours(slot.from)}–${msToAmPmHours(slot.to)}`}
            />
          </li>
        ))}
      </Fragment>
    );
  }
}

TimeSlotsList.propTypes = {
  slots: PropTypes.arrayOf(PropTypes.object.isRequired).isRequired,
  selectTimeSlot: PropTypes.func.isRequired,
  selectedTimeSlot: PropTypes.shape({
    from: PropTypes.number.isRequired,
    to: PropTypes.number,
  }).isRequired,
};
